import { buildStorageUrl } from "./storageUrl";

export const getProfileUrl = (
  user,
  defaultProfile = "profile.jpg",
) => {
  const profile =
    user?.profile ||
    user?.profileUrl ||
    defaultProfile;

  return buildStorageUrl(profile);
};
